import PropTypes from "prop-types";
import React, { Component } from "react";

import { sharedRequests } from "@/api/(requests)/shared";

import Button from "../../UI/Button";
import CardSecondary from "../../UI/Card/CardSecondary";

import "./styles.scss";

class ExceptionReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestId: props.requestId,
    };
  }

  handleTyping = (event) => {
    this.setState({ description: event.target.value });
  };

  handleSubmit = async () => {
    let report = {
      description: this.state.description ? this.state.description : "",
      request_id: this.state.requestId,
    };

    let response = await sharedRequests.post_exception_report({ report });

    this.props.dismiss();
  };

  render() {
    let { dismiss } = this.props;

    return (
      <div className="overlay">
        <div>
          <CardSecondary className="mx-lg-auto ExceptionReporting">
            <div className="px-5 py-4 text-center">
              <p>
                We are sorry your request failed. Please give us a description of your issue below:
              </p>
              <p> Request ID: {this.state.requestId}</p>
              <textarea className="w-100" onChange={this.handleTyping} />
              <div>
                <Button className="Btn Btn--pri m-1" onClick={this.handleSubmit}>
                  Submit
                </Button>
                <Button className="Btn Btn--gry m-1" onClick={dismiss}>
                  Cancel
                </Button>
              </div>
            </div>
          </CardSecondary>
        </div>
      </div>
    );
  }
}

ExceptionReport.propTypes = {
  dismiss: PropTypes.element.isRequired,
  requestId: PropTypes.element.isRequired,
};

export default ExceptionReport;
